import { Type, type Static } from '@sinclair/typebox';
import { PaginationQueryParamsSchema } from '../../shared/utils/pagination-query-params.schema';
import { StringEnum } from '../../utils/typebox';

export const GetRelationRequestsListQuerySchema = Type.Intersect([
  Type.Object({
    type: StringEnum(['sent', 'received'], {
      description: `Filter to returns only the given type of Relation / Follow request.
        - \`sent\` is the requests sent by the current user.
        - \`received\` is the requests received by the current user.`,
    }),
  }),
  PaginationQueryParamsSchema,
]);

export const CreateRelationRequestBodySchema = Type.Object({
  message: Type.Optional(
    Type.String({ description: 'A message to send to the user along with the request (if supported by the provider).' }),
  ),
  user_id: Type.String({ minLength: 1, description: 'The ID of the User to request a bi-directional relation with.' }),
});

export const CancelRelationRequestParamsSchema = Type.Object({
  request_id: Type.String({ minLength: 1, description: 'The ID of the Relation / Follow request.' }),
});

export const AcceptRelationRequestParamsSchema = Type.Object({
  request_id: Type.String({ minLength: 1, description: 'The ID of the Relation / Follow request.' }),
});

export type GetRelationRequestsListQuery = Static<typeof GetRelationRequestsListQuerySchema>;
export type CreateRelationRequestBody = Static<typeof CreateRelationRequestBodySchema>;
export type CancelRelationRequestParams = Static<typeof CancelRelationRequestParamsSchema>;
export type AcceptRelationRequestParams = Static<typeof AcceptRelationRequestParamsSchema>;
